<template>
  <div id="calendario" data-app>
    <TituloSeccion titulo="AGENDA" />
    <div class="v-application">
      <v-row class="fill-height col-12">
        <v-col>
          <div class="row row-cols-1 pb-3">
            <div class="col col-calendario">
              <v-btn
                class="botonVistaB float-right"
                @click.prevent="CambiarEventos"
              >
                {{ textoBotonEventos }}
              </v-btn>
              <v-btn
                class="botonVista float-right mr-2"
                @click="CambiarVistaCalendario"
              >
                {{ textoBotonVista }}
              </v-btn>
            </div>
          </div>
          <div class="row row-cols-sm-3 row-cols-lg-3 pb-4">
            <div class="col-2 col-calendario">
              <v-btn
                class="mx-2 flecha-calendario float-left"
                fab
                small
                @click="prev"
              >
                <i class="fas fa-caret-left fa-lg"></i>
              </v-btn>
            </div>
            <div class="col col-calendario">
              <v-toolbar-title style="color: #b8725a;">{{
                title
              }}</v-toolbar-title>
            </div>
            <div class="col-2 col-calendario">
              <v-btn
                class="mx-2 flecha-calendario float-right"
                fab
                small
                @click="next"
              >
                <i class="fas fa-caret-right fa-lg"></i>
              </v-btn>
            </div>
          </div>
          <v-sheet height="600">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="#b8725a"
              :events="eventosMaster"
              event-timed="timed"
              :event-color="getEventColor"
              :event-margin-bottom="3"
              :event-height="30"
              :now="today"
              :type="type"
              :weekdays="[1, 2, 3, 4, 5, 6, 0]"
              locale="es"
              :short-weekdays="false"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="true"
              :activator="selectedElement"
              offset-x
            >
              <v-card color="grey lighten-4" min-width="300px" flat>
                <v-toolbar :color="selectedEvent.color" light>
                  <v-toolbar-title
                    style="color: white;"
                    v-html="selectedEvent.name"
                  ></v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <span v-html="selectedEvent.details"></span>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="js">
//Componentes
import  "../../../../../plugins/vuetify.js";
//import "vuetify/dist/vuetify.min.css";
import servicios from '../../../servicios/service.js';
import TituloSeccion from "../../../Componentes/TituloSeccion.vue"
//Plugins
import axios from "axios";
//Rutas API
var rutaControladorLlamadas = "/api/Master/Llamada/ListarLlamadas";
var rutaControladorCitas = "/api/Master/Cita/ListarCitas";

export default {
  name: "Calendario",
  components: {
    TituloSeccion
  },
  data: () => ({
      today: new Date().toISOString().substr(0, 10),
      focus: new Date().toISOString().substr(0, 10),
      type: 'month',
      textoBotonVista: 'Vista por día',
      textoBotonEventos: 'Ver llamadas',
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      eventosMaster: [],
      // Adicionales...
      name: null,
      details: null,
      color: '#b8725a',
      dialog: false,
      currentlyEditing: null
    }),
    computed: {
      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }

        const startMonth = this.monthFormatter(start)
        const endMonth = this.monthFormatter(end)
        const suffixMonth = startMonth === endMonth ? '' : endMonth

        const startYear = start.year
        const endYear = end.year
        const suffixYear = startYear === endYear ? '' : endYear

        const startDay = start.day + this.nth(start.day)
        const endDay = end.day + this.nth(end.day)

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`
          case 'week':
          case '4day':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
          case 'day':
            return `${startMonth} ${startDay} ${startYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
    },
    mounted () {
      this.$refs.calendar.checkChange();
      this.CargarLlamadas();
      this.CargarCitas();
    },
    methods: {
      CambiarEventos () {
        this.eventosMaster = [];
        if(this.textoBotonEventos == 'Ver llamadas') {
          this.CargarLlamadas();
          this.textoBotonEventos = 'Ver citas'
        } else {
          this.CargarCitas();
          this.textoBotonEventos = 'Ver llamadas'
        }
      },
      CambiarVistaCalendario(){
        if (this.type === 'month') {
          this.type = 'day';
          this.textoBotonVista = 'Vista por mes'
        } else {
          this.type = 'month';
          this.textoBotonVista = 'Vista por día'
        }
      },
      CargarCitas() {
        axios.get(rutaControladorCitas)
        .then(response => {
          if(response.data.estado === 0) {
            var citas = response.data.data;
            citas.forEach(c => {
              let cita = {
                name: "Cita con " + c.nombre.charAt(0).toUpperCase() + c.nombre.slice(1).toLowerCase(),
                start: servicios.DarFormatoFecha(new Date(c.fechaInicio)),
                end: servicios.DarFormatoFecha(new Date(c.fechaFin)),
                color: '#b8725a',
                details: "<div style='text-align: left;'><label>Prospecto: </label> <b style='font-sieze: 14px;'>" + c.nombre + " " + c.apellido +"</b> <br>" +
                "<label>Fecha: </label><b>"+" " + c.fechaInicio.substring(0,10) +"</b><br>" +
                "<label>De las: </label><b>"+ " " + c.horaInicio + " a las " + c.horaFin + "</b> <br>" +
                "<label>Embajador: </label> <b>"+ " " + c.embajador + "</b></div>"
              }
              this.eventosMaster.push(cita);
            });
          }
        }).catch(e => {
          this.ManejarExcepcion(e);
        });
      },
      CargarLlamadas() {
      axios
        .get(rutaControladorLlamadas)
        .then(response => {
          if (response.data.estado === 0) {
            var llamadas = response.data.data;
            llamadas.forEach(call => {
              let llamada = {
                name: "Llamada con " + call.nombre.charAt(0).toUpperCase() + call.nombre.slice(1),
                start: servicios.DarFormatoFecha(new Date(call.fecha)),
                end:  servicios.DarFormatoFecha(new Date(call.fecha)),
                color: '#b8725a',
                details: "<div style='text-align: left;'><label>Prospecto: </label> <b style='font-sieze: 14px;'>" + call.nombre + " " + call.apellido +"</b> <br>" +
                "<label>Fecha: </label><b>"+" " + call.fecha.substring(0,10) +"</b><br>" +
                "<label>Hora: </label><b>"+ " " + call.hora + ":" + call.minutos + "</b> <br>" +
                "<label>Embajador: </label> <b>"+ " " + call.embajador + "</b></div>"
              }
              this.eventosMaster.push(llamada);
            });
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
        this.textoBotonVista = 'Vista por mes';
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = this.today
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
        this.start = start
        this.end = end
      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
    }
};
</script>

<style scoped lang="scss">
.v-application {
  display: block;
  padding-left: 20px;
}
.v-application .primary {
  background-color: rgba(105, 97, 88, 1);
  border-color: rgba(105, 97, 88, 1);
}
.v-application .primary--text {
  color: rgba(105, 97, 88, 1);
  border-color: rgba(105, 97, 88, 1);
}
.v-btn__content {
  color: rgba(105, 97, 88, 1);
}
.container {
  margin-right: 0;
  margin-left: 0;
}
.botonVista {
  background-color: #b8725a !important;
  border-radius: 0px;
  box-shadow: none;
  color: white !important;
  font-family: "Poppins";
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  height: 47px;
  letter-spacing: 0.05em;
}
.botonVistaB {
  background-color: #ffffff !important;
  border: 1px solid #b8725a;
  border-radius: 0px;
  box-shadow: none;
  color: #b8725a !important;
  font-family: "Poppins";
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  height: 47px;
  letter-spacing: 0.05em;
}
.flecha-calendario {
  background-color: #b8725a !important;
  color: white;
  box-shadow: none;
}
.v-toolbar__title {
  font-family: "Poppins";
  color: #b8725a;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.22em;
}
.v-calendar-weekly__day-label .v-btn {
  background-color: #b8725a !important;
}
@media (max-width: 512px) {
  .col-calendario {
    display: flex;
    justify-content: center;
  }
  .botonVista {
    margin: 10px;
  }
  .botonVistaB {
    margin: 10px;
  }
}
</style>
